export default function MenuList({ children }) {
  return <ul className="p-0 m-0">{children}</ul>;
}
